$(window).load(function(){
	matchHeight();
    product_carousel();
    testimonial_carousel();
    featured_carousel();
});
$(document).ready(function(){
	product_carousel();
    matchHeight();
    testimonial_carousel();
    featured_carousel();
});

/*
	Variable Functions ==========================================================
*/
function product_carousel(){
	jQuery('.product-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa-solid fa-arrow-left-long'></i>", "<i class='fa-solid fa-arrow-right-long'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:2,

			},
			1000:{

				items:3,
			}
		}
	})
}

function testimonial_carousel(){
	jQuery('.testimonial-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa fa-chevron-left'></i>", "<i class='fa fa-chevron-right'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:1,

			},
			1000:{

				items:1,
			}
		}
	})
}

function featured_carousel(){
	jQuery('.featured-carousel').owlCarousel({
		loop:true,
		nav: true,
		navText: ["<i class='fa fa-long-arrow-left'></i>", "<i class='fa fa-long-arrow-right'></i>"],
		responsiveClass:true,
		autoplay:true,
		autoplayTimeout:3000,
		autoplayHoverPause:true,
		responsive:{

			0:{

				items:1,

			},
			600:{

				items:2,

			},
			1000:{

				items:2,
			}
		}
	})
}


function matchHeight() {
  console.log("matchHeightisWorking");
  jQuery('.content-container').matchHeight();
}















